import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

const PrivateRoute = ({ children, adminOnly = false }) => {
    const { isAuthenticated, user } = useContext(AuthContext);
    const location = useLocation();

    if (!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // Vérifie si la route est réservée à l'administrateur et si l'utilisateur est un administrateur
    if (adminOnly && user?.roleNames?.includes("ADMIN") === false) {
        return <Navigate to="/home" replace />;
    }

    return children;
};

export default PrivateRoute;